import React from 'react'
import styled from 'styled-components'

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string
  disabled?: boolean
}

const TextInputView: React.FC<TextInputProps> = styled.input<TextInputProps>`
  color: #0e76eb;
  width: 100%;
  border: none;
  transition: all 0.2s ease;
  background-color: transparent;
  font-size: 14px;
  outline: none;
  resize: none;
  overflow: hidden;
  text-align: left;
  border-bottom: 1px solid rgba(176, 180, 186, 0.42);

  &:disabled {
    border-bottom: 1px solid transparent;
  }
`

export const TextInput: React.FC<TextInputProps> = ({ className, value = '', ...props }) => (
  <TextInputView {...props} type='text' autoComplete='off' value={value} />
)
